// src/components/routes/Sign/ForgotPassword/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AuthShell from '../AuthShell/AuthShell';
import './ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setError('');

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}/send-otp`, { email });
            setMessage(response.data.message || 'Password reset link has been sent to your email. Please check your inbox.');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send reset link. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AuthShell
            eyebrow="Password recovery"
            title="Let’s get you back in"
            description="Enter the email linked to your account. We’ll send you a secure password reset link."
            asideTitle="A small reset. No lost momentum."
            asideDescription="Your workspace and customer history stay exactly where you left them. Reset securely and continue with confidence."
        >
            {message && (
                <div className="auth-alert auth-alert-success" role="status">
                    <i className="fas fa-check-circle" aria-hidden="true" />
                    <span>{message}</span>
                </div>
            )}
            {error && (
                <div className="auth-alert auth-alert-error" role="alert">
                    <i className="fas fa-exclamation-circle" aria-hidden="true" />
                    <span>{error}</span>
                </div>
            )}
            <form className="auth-form" onSubmit={handleSubmit}>
                <div className="auth-field">
                    <label htmlFor="recovery-email">Email address</label>
                    <div className="auth-input-wrap">
                        <i className="fas fa-envelope auth-input-icon" aria-hidden="true" />
                        <input
                            id="recovery-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@company.com"
                            required
                            disabled={isLoading}
                        />
                    </div>
                </div>
                <button className="auth-submit" type="submit" disabled={isLoading || Boolean(message)}>
                    {isLoading ? (
                        <><i className="fas fa-circle-notch fa-spin" /> Sending secure link...</>
                    ) : (
                        <>Send reset link <i className="fas fa-paper-plane" /></>
                    )}
                </button>
            </form>
            <div className="auth-form-footer">
                <Link className="auth-inline-link" to="/login">
                    <i className="fas fa-arrow-left" aria-hidden="true" /> Back to sign in
                </Link>
            </div>
        </AuthShell>
    );
};

export default ForgotPassword;
